import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListEmspUserLastNameCell } from './emsp-bo-invoice-list-emsp-user-last-name.cell';
import { EmspBoInvoiceListEmspUserLastNameHeader } from './emsp-bo-invoice-list-emsp-user-last-name.header';

export const EmspBoInvoiceListEmspUserLastNameColumn: IdentifiedColumnDef<
  EmspUserInvoiceBaseModel,
  EmspUserInvoiceBaseModel['emspUser']['lastName']
> = {
  id: 'emspUserLastName',
  enableSorting: false,
  header: EmspBoInvoiceListEmspUserLastNameHeader,
  cell: EmspBoInvoiceListEmspUserLastNameCell,
};
